<script>
    import modalService from '@/services/core/modal.service';
    import Modal from '@/components/modals/Modal';
    import utilsService from '@/services/core/utils.service';
    import administratorsService from '@/services/administrators.service';
    import ButtonSpinner from '@/components/shared/ButtonSpinner';

    export default {
        props: {
            modalData: Object
        },
        components: {
            Modal,
            ButtonSpinner
        },
        data() {
            return {
                isLoading: 0,
                item: {
                    userName: '',
                    fullName: '',
                    isReadOnly: false,
                    permissions: {
                        hasDemoAccess: false,
                        hasTinyPumperAccess: false,
                        hasBillingAccess: false
                    }
                },
                permissionsChecks: [
                    { key: 'hasDemoAccess', label: 'Demo' },
                    { key: 'hasTinyPumperAccess', label: 'Tiny Pumper' },
                    { key: 'hasBillingAccess', label: 'Billing' }
                ]
            };
        },
        computed: {
            isNew() {
                return !this.item?.id;
            }
        },
        methods: {
            close() {
                modalService.closeModal();
            },
            getById(id) {
                this.isLoading++;
                administratorsService
                    .getById(id)
                    .then(item => (this.item = item || {}))
                    .finally(() => this.isLoading--);
            },
            save() {
                this.isLoading++;

                const promise = this.isNew ? administratorsService.create(this.item) : administratorsService.save(this.item.id, this.item);

                promise
                    .then(() => {
                        utilsService.showToast(`Admin User was ${this.isNew ? 'created' : 'updated'} successfully`);
                        this.modalData.onSuccess && this.modalData.onSuccess();
                        this.close();
                    })
                    .finally(() => this.isLoading--);
            }
        },
        mounted() {
            if (this.modalData?.userId) this.getById(this.modalData?.userId);
        }
    };
</script>

<template>
    <Modal>
        <form class="gsb-form" @submit.prevent="save">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">Edit Admin User</h3>
                </div>
                <div class="modal-body">
                    <fieldset>
                        <div class="row mb-3">
                            <label class="col-sm-4 col-form-label">Email</label>
                            <div class="col-sm">
                                <input v-model="item.userName" type="email" class="form-control" required />
                            </div>
                        </div>

                        <div class="row mb-3">
                            <label class="col-sm-4 col-form-label">Full Name</label>
                            <div class="col-sm">
                                <input v-model="item.fullName" type="text" class="form-control" required />
                            </div>
                        </div>

                        <div class="row mb-3">
                            <label class="col-sm-4 col-form-label" for="isReadOnly">Is Read-Only User?</label>
                            <div class="col-sm">
                                <input
                                    id="isReadOnly"
                                    type="checkbox"
                                    v-model="item.isReadOnly"
                                    class="form-check-input"
                                    style="width: 20px; height: 20px"
                                />
                            </div>
                        </div>

                        <template v-if="!item.isReadOnly">
                            <h5>Permissions</h5>
                            <div v-for="(pch, i) in permissionsChecks" :key="`permissionsChecks-${i}`" class="row align-items-center">
                                <label :id="pch.key" class="col-sm-4 col-form-label ps-4">{{ pch.label }}</label>
                                <div class="col-sm">
                                    <input
                                        :id="pch.key"
                                        type="checkbox"
                                        class="form-check-input"
                                        style="width: 20px; height: 20px"
                                        v-model="item.permissions[pch.key]"
                                    />
                                </div>
                            </div>
                        </template>
                    </fieldset>
                </div>

                <div class="modal-footer d-flex justify-content-between">
                    <button type="button" class="btn" @click="close">Close</button>
                    <ButtonSpinner :isLoading="isLoading" />
                </div>
            </div>
        </form>
    </Modal>
</template>
